<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;"><img alt="" src="media/file0.png" style="width:1.91942in;height:2.33044in"/></p><br/>
<p style="text-indent:0em">Antonio Evaristo Morales-Pita, PhD was adjunct faculty of economics at the College of Business of DePaul University, Chicago, since 1999 to 2016, simultaneously assistant professor of international political economy at the international studies department of the same university. During 45 years, he has been working as an educator in Cuban, Mexican and American universities. He is the author of 10 books and of more than 150 papers related to the application of mathematical models to economics, to the economic evaluation and solution of environmental problems, and to the teaching of economics. He is recipient of the 2007 Excellence in Teaching Award at DePaul University, of the Cátedra Patrimonial de CONACyT 2005–2006 grant at the Merida’s Institute of Technology, Yucatán, Mexico, and of awards as outstanding professor and researcher granted by the Cuban Higher Education System, the Cuban Academy of Sciences, the Union of University Professors of Cuba, and the University of Havana.</p><br/>
<p style="text-indent:0em">Following the first edition of the book <em>Havana-Merida-Chicago (A Journey to Freedom)</em>, he became columnist at La Raza weekly newspaper in Chicago and at the electronic journal www.cubanalisis.com.</p><br/>
<p style="text-indent:0em">He has offered talks about the book at Clarion University of Pennsylvania, Robert Morris University, DePaul University, Northeastern University, and St. Augustine College, as well as at several middle and elementary schools, and the Fox Valley Forge in Aurora, IL, and the Firm Royal Prestige in Bensenville, IL.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?55cd9d55